/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FeedbackInsightList = {
  readonly uuid: string
  type: FeedbackInsightList.type
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `SKIPPED` - Skipped
   */
  status?: FeedbackInsightList.status
  skip_reason?: string | null
}

export namespace FeedbackInsightList {
  export enum type {
    FEEDBACK_PER_LABEL_AND_REASON = "FEEDBACK_PER_LABEL_AND_REASON",
    FEEDBACK_PROFILE = "FEEDBACK_PROFILE",
    FEEDBACK_CORRELATION = "FEEDBACK_CORRELATION",
    FEEDBACKS_PER_WORKFLOW_MODEL = "FEEDBACKS_PER_WORKFLOW_MODEL",
    FEEDBACK_COUNT = "FEEDBACK_COUNT",
  }
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `SKIPPED` - Skipped
   */
  export enum status {
    PENDING = "PENDING",
    RUNNING = "RUNNING",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
    SKIPPED = "SKIPPED",
  }
}
